import { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import "../../styles.css";
import CreatorsTable from "./table";
import CreatorModal from "./modal";
import {useDropzone} from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useToasts } from "react-toast-notifications";
import "./style.scss";

const baseStyle = {
  // flex: 1,
  // display: 'flex',
  // flexDirection: 'column',
  textAlign: 'center',
  // padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
  cursor: 'pointer'
};

const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};

const SuggestedCreators = () => {
  const { addToast } = useToasts();

  const perPage = 10;
  const [busy, setBusy] = useState(false);
  const [login, setLogin] = useState("");
  const [page, setPage] = useState(1);
  const [pageItems, setPageItems] = useState(0);
  const [total, setTotal] = useState(0);
  const [sortBy, setSortBy] = useState('pu.login');
  const [isRefresh, setRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [creators, setCreators] = useState([]);
  const [users, setUsers] = useState([]);
  const [isUpdateCreator, setUpdateCreator] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [tableAction, setTableAction] = useState(null);
  const [editParams, setEditParams] = useState(null);
  const [paginated, setPaginated] = useState([]);
  const [menuIsOpen, setMenuOpen] = useState(false);
  const [orderBy, setOrderBy] = useState({
    header: "rank",
    order: "ASC"
  });
  const [file, setFile] = useState('')
  const [error, setError] = useState('')

  const onDropRejected = useCallback(() => {
    setError('Only .csv file is accepted');
  }, []);

  const onDropAccepted = useCallback((acceptedFiles) => {
    setError('')
    setFile(acceptedFiles[0])
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone({
    onDropRejected,
    onDropAccepted,
    accept: '.csv',
    maxFiles: 1,
    multiple: false,
  });


  const style = useMemo(() => ({
    ...baseStyle,
    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isDragActive,
    isDragReject,
    isDragAccept
  ]);
  

  useEffect(() => {
    if (login) setBusy(true);
    getCreators();
  }, [page, orderBy, sortBy, isRefresh, isUpdateCreator])

  const getCreators = () => {
    console.log('get creators')
    axios.get("/api/administration/creators", {
      params: {
        // page: page,
        header: orderBy.header,
        order: orderBy.order,
        // per_page: perPage
      },
    })
    .then((response) => {
      const data = response.data;
      console.log(data);
      setCreators(response.data);
      // setPaginated(data.creators);
      // setTotal(data.total);
      setUpdateCreator(false);
      // setPageItems(Math.ceil(data.total / perPage));
    })
    .catch((error) => {
      console.log(error)
      setBusy(false);
      setRefresh(false);
      setUpdateCreator(false);
    })
  }

  const getPUs = (keyword) => {
    console.log(keyword);
    setIsLoading(true)
    axios.get("/api/administration/creators/pu", {
      params: {
        search: keyword,
      },
    })
    .then((response) => {
      const data = response.data;
      console.log(data);
      setUsers(data.users);
      // setMenuOpen(false);
      setIsLoading(false)
    })
    .catch((error) => {
      setMenuOpen(false);
      setIsLoading(false)
      console.log(error.response)
    })
  }

  const getAllCreators = (keyword) => {
    console.log(keyword);
    setIsLoading(true)
    axios.get("/api/administration/creators/all", {
      params: {
        search: keyword,
      },
    })
    .then((response) => {
      const data = response.data;
      console.log(data);
      setUsers(data.users);
      setIsLoading(false)
      // setMenuOpen(false);
    })
    .catch((error) => {
      setMenuOpen(false);
      console.log(error.response)
      setIsLoading(false)
    })
  }

  const handleActionTable = (action, params={}) => {
    setTableAction(action)

    if(action == 'edit'){
      setEditParams(params);
    }else{
      setEditParams(null);
    }

    setShowModal(true);
  }

  const handleCsvUpload = async () => {
    setBusy(true)
    const formData = new FormData();
    formData.append('file', file);

    await axios.post(
      `/api/administration/creators/upload`,
      formData,
      {
          headers: {
          'Content-Type': 'multipart/form-data',
          },
      },
    ).then(() => {
      getCreators()
      setFile('')
      addToast('CSV succesfully uploaded', { appearance: 'success', autoDismiss: true });
      setBusy(false)
    }).catch(error => {
      setBusy(false)
      addToast('Unable to upload CSV file', { appearance: 'error', autoDismiss: true });
    })
  }

  return (
    <div style={{width: '100%'}} className="suggested-creators">
      <h3 className="mb-4">Suggested Creators</h3>

      <CreatorsTable
        creators={creators}
        paginated={paginated}
        users={users}
        pageItems={pageItems}
        tableAction={tableAction}
        total={total}
        page={page}
        orderBy={orderBy}
        isLoading={isLoading}
        setPage={setPage}
        setOrderBy={setOrderBy}
        handleActionTable={handleActionTable}
        setTableAction={setTableAction}
        setCreators={setCreators}
      />

      <CreatorModal
        creators={creators}
        users={users}
        total={total}
        params={editParams}
        tableAction={tableAction}
        showModal={showModal}
        menuIsOpen={menuIsOpen}
        getPUs={getPUs}
        getAllCreators={getAllCreators}
        setMenuOpen={setMenuOpen}
        setShowModal={setShowModal}
        setUpdateCreator={setUpdateCreator}
        isBusy={isLoading}
      />

        <div className="row mt-5">
          <div className="col-md-12">
            <h3 className="mb-2">Importing List of Suggested Creators</h3>
            <div className="alert alert-info py-1 px-2">
              Only csv file is accepted.  Invalid PU IDs are automatically ignored.
            </div>
            { error && <div className="alert alert-danger py-1 px-2">
              { error }
            </div> }
          </div>
          <div className="col-md-4">
            <div {...getRootProps({style})}>
              <input {...getInputProps()} />
              {
                isDragActive
                  ? <p>Drop the file here...</p>
                  : <p>Drag and drop or click to add csv file</p>
              }
            </div>
            <div className="my-3">
            {
              file && <FontAwesomeIcon icon={['fas', 'file-csv']} />
            }
            {' '}
            {
              file
                ? file.path
                : ''
            }
            {' '}
            {file && <a href="#" onClick={(e) => { e.preventDefault(); setFile('')}}><FontAwesomeIcon icon={['fas', 'times-circle']} /></a>}
            </div>
          </div>
          
          <div className="col-md-4">
            <button
              type="button"
              className="btn btn-sm btn-primary"
              disabled={!file || busy}
              onClick={handleCsvUpload}
            >
              { busy ? 'Uploading...' : 'Upload'}
            </button>
          </div>
        </div>
    </div>
  );
};

export default SuggestedCreators;
